import React, { useCallback, useEffect, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import sessionDB from '../utils/sessionDB';
import LoginAnnouncementsModal from './LoginAnnouncementsModal';
import YesterdayCheckoutModal from '../modules/attendance-management/components/YesterdayCheckoutModal';
import { checkYesterdayCheckout } from '../services/attendanceService';

export default function LoginAttendanceFlow({ announcements, onComplete, initialStage = 'checking' }) {
  const [state, setState] = useState({ status: initialStage === 'announcements' ? 'announcements' : 'checking', record: null });
  const [attempt, setAttempt] = useState(0);

  const showAnnouncements = useCallback(() => {
    sessionDB.updateSession({ loginAttendanceStage: 'announcements' });
    setState({ status: 'announcements' });
  }, []);

  useEffect(() => {
    if (initialStage === 'announcements') return;
    let active = true;
    setState({ status: 'checking', record: null });
    checkYesterdayCheckout().then(record => {
      if (!active) return;
      if (record == null) showAnnouncements();
      else setState({ status: 'checkout', record });
    }).catch(error => {
      if (!active) return;
      // Attendance permissions are not available to every tenant user.
      if (error.status === 403) showAnnouncements();
      else setState({ status: 'error', error: error.message });
    });
    return () => { active = false; };
  }, [attempt, initialStage, showAnnouncements]);

  useEffect(() => {
    if (state.status === 'announcements' && !announcements.length) onComplete();
  }, [state.status, announcements.length, onComplete]);

  if (state.status === 'checkout') {
    return <YesterdayCheckoutModal record={state.record} onSuccess={showAnnouncements} />;
  }
  if (state.status === 'announcements') {
    return announcements.length ? <LoginAnnouncementsModal announcements={announcements} onClose={onComplete} /> : null;
  }
  return (
    <Dialog.Root open>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[9000] bg-black/60" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-[9001] w-[calc(100vw-32px)] max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-xl border border-border bg-background p-6 text-foreground shadow-2xl">
          <Dialog.Title className="text-xl font-semibold">Checking yesterday's attendance</Dialog.Title>
          <Dialog.Description className="mt-3 text-sm text-muted-foreground">
            {state.status === 'error' ? (state.error || 'Unable to check yesterday’s checkout. Please retry.') : 'Please wait while we check for a missing checkout.'}
          </Dialog.Description>
          {state.status === 'error' && <button type="button" className="mt-4 rounded-md bg-primary px-5 py-2 text-primary-foreground" onClick={() => setAttempt(value => value + 1)}>Retry</button>}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}